<template>
<div>
    <page-header title="Networks"></page-header>
    <content-loader v-if="$apollo.loading" title="Networks" />
    <div class="network-list" v-else>
        <div class="container">
            <div v-for="(type, index) in types" :key="index">
                <h3 class="title" v-if="filterNetworksByType(type).length">{{ type }} Networks</h3>
                <div class="row" v-if="networks">
                    <a
                        class="col-md-6 col-lg-4 mb-4"
                        v-for="network in filterNetworksByType(type)"
                        :key="network.id"
                        v-router-link="{ name:'NetworkDetail', params: { id: network.id }}"
                    >
                        <network-card :network="network"></network-card>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {ListNetworks} from "@/gql/ListNetworks.gql";
import PageHeader from '@/components/global/PageHeader';
import ContentLoader from '@/components/global/ContentLoader';
import NetworkCard from '@/components/networks/NetworkCard';

export default {
    components: {
        PageHeader,
        ContentLoader,
        NetworkCard
    },

    apollo: {
        networks: {
            query: ListNetworks
        }
    },

    data() {
        return {
            networks: null,
            query: "",
            types: [
                "Role",
                "Sector",
                "Other"
            ]
        }
    },

    methods: {
        filterNetworksByType(type) {
            var sorted = this.networks.slice().sort((a,b)=> b.stats.membercount-a.stats.membercount);
            return sorted.filter((network) => {
                return network.type.toLowerCase() === type.toLowerCase();
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.network-list {
    padding: 15px 0;

    @include media-breakpoint-up(md) {
        padding: 35px 0;
    }

    .title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
        @include media-breakpoint-up(md) {
            margin-bottom: 35px;
        }
    }

    .row {
        margin-bottom: 30px;
    }

    a {
        cursor: pointer;

        &:hover {
            color: $primary;
        }
    }
}
</style>
